// extracted by mini-css-extract-plugin
export var deleteModal = "_sn-0";